export { default } from '@relo/sports-components/es/AccordionContainer';
export * from '@relo/sports-components/es/AccordionContainer';
